import './PageBody.css';

export const PageBody = (props: any) => {

  const {
    children
  } = props;

  return (
    <div className="page-body">
      <div className='page-v-content'>
        <div className='page-body-content'>
          {children}
        </div>
      </div>
    </div>
  )
}